import React from 'react';
import { isEmpty } from 'ramda';
import PropTypes from 'prop-types';
import { Box, Typography, TextField, InputAdornment } from '@material-ui/core';

import useStyles from './useStyles';

const BidFormValueField = props => {
  const classes = useStyles();
  const { label, value, prefix, suffix } = props;
  const isPrefixPresent = !isEmpty(prefix);
  const isSuffixPresent = !isEmpty(suffix);
  const fieldValue = Number.isNaN(value) ? '--' : value;

  return (
    <Box className={classes.container}>
      <Typography variant="subtitle1" color="secondary">
        {label}
      </Typography>
      <TextField
        variant="outlined"
        value={fieldValue}
        disabled
        className={classes.field}
        InputProps={{
          startAdornment: isPrefixPresent ? <InputAdornment position="start">{prefix}</InputAdornment> : null,
          endAdornment: isSuffixPresent ? <InputAdornment position="end">{suffix}</InputAdornment> : null,
          classes: { adornedStart: classes.adornment, adornedEnd: classes.adornment },
        }}
      />
    </Box>
  );
};

BidFormValueField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
};

BidFormValueField.defaultProps = {
  prefix: '',
  suffix: '',
};

export default BidFormValueField;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/components/AutoCalculation/components/BidFormValueField/BidFormValueField.js